import React from 'react';
import { Field, Spinner } from '../../components/ui';
import { fullName, fmtDate } from '../../utils/helpers';
import { dueText, toTimeInput } from './useReminders';
import ReminderForm from './ReminderForm';

// Desktop Reminders — reminder cards + calling-list table.
export default function RemindersDesktop({ vm }) {
  const {
    canUse, canManage, canDelete, reminders, selected, setSelectedId, isSelected, activeCount,
    callDate, setCallDate, rows, called, loading, listLoading, modalOpen, openAdd, openEdit, deleteReminder, toggleCalled,
  } = vm;

  if (!canUse) {
    return (
      <div>
        <div className="page-head"><h1>Invitation Reminders</h1></div>
        <div className="card card-pad empty">You do not have access to reminders for this event.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <h1>Invitation Reminders</h1>
        <span className="muted">{activeCount} active</span>
        <div className="spacer" />
        {canManage && <button className="btn primary" onClick={openAdd}>+ Add Reminder</button>}
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div> : reminders.length === 0 ? (
        <div className="card card-pad empty">
          No reminders yet. Add a from date and time to start the daily invitation calling list.
        </div>
      ) : (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 10, marginBottom: 12 }}>
            {reminders.map(r => {
              const active = isSelected(r);
              return (
                <div key={r.ReminderId} className="card card-pad row-link" role="button" tabIndex={0}
                  onClick={() => setSelectedId(r.ReminderId)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSelectedId(r.ReminderId); } }}
                  style={{ borderColor: active ? 'var(--brand)' : 'var(--line)', background: active ? 'var(--soft)' : 'var(--card)' }}>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <strong>{r.Title || 'Invitation Calls'}</strong>
                    <span className={Number(r.Active) === 1 ? 'chip ok' : 'chip pend'}>{Number(r.Active) === 1 ? 'Active' : 'Paused'}</span>
                  </div>
                  <div className="muted" style={{ fontSize: 13, marginTop: 6 }}>
                    From {fmtDate(r.StartDate)} at {toTimeInput(r.ReminderTime)}
                  </div>
                  <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }} onClick={(e) => e.stopPropagation()}>
                    <span className="chip warn">{dueText(r, callDate)}</span>
                    <div style={{ flex: 1 }} />
                    {canManage && <button type="button" className="btn sm light" onClick={() => openEdit(r)}>Edit</button>}
                    {canDelete && <button type="button" className="btn sm danger" onClick={() => deleteReminder(r)}>Delete</button>}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="card card-pad" style={{ marginBottom: 12 }}>
            <div className="form-grid">
              <Field label="Calling date" type="date" value={callDate} onChange={setCallDate} />
              <div>
                <div className="muted" style={{ fontSize: 12, marginBottom: 6 }}>Progress</div>
                <div><strong>{called}</strong> called / <strong>{rows.length}</strong> guests</div>
                {selected && <div className="muted" style={{ fontSize: 12 }}>{dueText(selected, callDate)}</div>}
              </div>
            </div>
          </div>

          <div className="card table-wrap">
            {listLoading ? <Spinner /> : rows.length === 0 ? (
              <div className="empty">No guests found for this reminder.</div>
            ) : (
              <table className="tbl compact">
                <thead>
                  <tr><th>Called</th><th>Time</th><th className="grow">Guest</th><th>Mobile</th><th>Function</th><th>Status</th><th>Called By</th></tr>
                </thead>
                <tbody>
                  {rows.map(row => (
                    <tr key={row.GuestId} className="row-link" onClick={() => toggleCalled(row)}>
                      <td onClick={(e) => e.stopPropagation()}>
                        <input type="checkbox" checked={Number(row.Called) === 1} onChange={() => toggleCalled(row)} style={{ width: 18, height: 18 }} />
                      </td>
                      <td>{row.ReminderSlot || '-'}</td>
                      <td className="grow">
                        <strong>{fullName(row)}</strong>
                        <div className="sub">Added by {(row.AddedByName || '').trim() || '-'}</div>
                      </td>
                      <td>{row.MobileNumber || '-'}</td>
                      <td>{row.FunctionName || '-'}</td>
                      <td><span className={Number(row.Called) === 1 ? 'chip ok' : 'chip pend'}>{Number(row.Called) === 1 ? 'Called' : row.InviteStatus || 'Pending'}</span></td>
                      <td>{Number(row.Called) === 1 ? ((row.CalledByName || '').trim() || 'You') : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}

      {modalOpen && <ReminderForm vm={vm} />}
    </div>
  );
}
